import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// MeR 251114 React 19.2.0 make this like digitalservices.ma & sync.2us.ma
// MeR 250106 React 19.0.0